module.exports = __webpack_public_path__ + "static/right-img1-fa65ab5cdc599c664642ab1bedaace60.svg";